// src/security/sessionUser.js

const SESSION_KEY = 'sigmaUser';

const DEFAULT_TIMEOUT_MINS = 5; // Valor por defecto de 5 minutos

export function setSessionUser({ idUsuario, nombreUsuario, minutosInactividad }) {
  if (!idUsuario || !nombreUsuario) {
    console.warn('setSessionUser llamado sin idUsuario o nombreUsuario', {
      idUsuario,
      nombreUsuario,
    });
  }

  const payload = {
    idUsuario,
    nombreUsuario,
    minutosInactividad: minutosInactividad || DEFAULT_TIMEOUT_MINS
  };
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(payload));
}

export function getSessionUser() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (err) {
    console.error('Error leyendo sessionUser', err);
    return null;
  }
}

export function getSessionUserId() {
  const u = getSessionUser();
  return u?.idUsuario ?? null;
}

export function getSessionUserName() {
  const u = getSessionUser();
  return u?.nombreUsuario ?? '';
}

export function getSessionTimeoutMinutos() {
  const u = getSessionUser();
  return u?.minutosInactividad ?? DEFAULT_TIMEOUT_MINS;
}

export function clearSessionUser() {
  sessionStorage.removeItem(SESSION_KEY);
}

export function updateSessionTimeout(minutos) {
  const u = getSessionUser();
  if (u) {
    u.minutosInactividad = minutos;
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(u));
  }
}
